// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"styles_avatarWrapper__mQ7OH","avatar":"styles_avatar__FrZOV"};